































































































































import { cloneDeep } from "lodash";
import { ValidationObserver } from "vee-validate";
import { Component, VModel, Prop, PropSync, Mixins, Watch, Emit } from 'vue-property-decorator';

import ModelSetter from "../../../Mixins/ModelSetter";
import MiniHelpMessage from "../../../components/MiniHelpMessage/MiniHelpMessage.vue";
import NestedContent from "../../../components/Pi/components/NestedContent.vue";
import SelectInput from "../../../components/Pi/fields/SelectInput/SelectInput.vue";
import TextInput from "../../../components/Pi/fields/TextInput/TextInput.vue";
import { FieldData } from "../../../components/Pi/types";
import CashRegisterDataSettings from "../../../components/Shop/CashRegisters/CashRegisterDataSettings.vue";
import CashRegisterEditorMixin from "../../../components/Shop/CashRegisters/CashRegisterEditorMixin";
import CashRegisterHint from "../../../components/Shop/CashRegisters/CashRegisterHint.vue";
import {
  CashRegisterModel, CashRegisterType,
  CreateCashRegisterModel,
  UpdateCashRegisterModel
} from "../../../components/Shop/CashRegisters/types";
import { successNotificationWrapper, warningNotificationWrapper } from "../../../logic/helpers/NotificationService";
import { XTR_CURRENCY } from "./constants";

@Component({
  data() {
    return {
      CashRegisterType,
      XTR_CURRENCY
    }
  },
  components: {
    SelectInput,
    CashRegisterDataSettings,
    MiniHelpMessage,
    CashRegisterHint,
    NestedContent,
    TextInput,
    ValidationObserver
  }
})
export default class CashRegisterSetup extends Mixins(ModelSetter, CashRegisterEditorMixin) {
  @VModel({ default: null }) target!: number | null | undefined

  @PropSync('visible', { type: Boolean, default: false }) isModalOpen!: boolean

  @Prop() initialName!: string | undefined

  @Prop() createCashRegister!: (system: CreateCashRegisterModel) => Promise<void | CashRegisterModel>

  @Prop() updateCashRegister!: (system: UpdateCashRegisterModel, isDataChanged: boolean) => Promise<void | Array<CashRegisterModel>>

  @Prop() getCashRegister!: (id: number) => CashRegisterModel | undefined

  model: CreateCashRegisterModel | UpdateCashRegisterModel | null = null

  isCredentialsSettingOpen = false

  isRequestProcessing = false

  @Emit()
  inputCashRegister(register: CashRegisterModel) {
    return register
  }

  @Watch('isModalOpen')
  onTargetChange(state: boolean) {
    if (state) {
      this.setLocalModel()
    }
  }

  get currOptions() {
    if (this.model) {
      return this.currencyList(this.model.type)
    }

    return []
  }

  get modalTitle() {
    if (!this.target) {
      return this.$t('create_cash_register_title').toString()
    } else {
      return this.$t('edit_cash_register_title').toString()
    }
  }

  setCashRegisterType(arg: FieldData): FieldData {
    arg.setter = (val) => {
      if (this.model) {
        this.model.type = val

        this.model.currency = this.currencyList(val).at(0)?.value ?? ''
      }
    }

    return arg
  }

  cancel() {
    this.model = null
    this.isCredentialsSettingOpen = false
  }

  getDefaultCashRegisterModel() {
    return cloneDeep({
      currency: this.$i18n.locale === 'ru' ? 'RUB' : 'USD',
      name: this.initialName ?? '',
      type: CashRegisterType.Telegram,
      data: this.getCashRegisterDataByType(CashRegisterType.Telegram)
    })
  }

  setLocalModel() {
    if (this.target) {
      const cashRegister = this.getCashRegister(this.target)

      if (cashRegister) {
        this.model = { ...cloneDeep(cashRegister), data: this.getCashRegisterDataByType(cashRegister.type) }
      } else {
        this.model = this.getDefaultCashRegisterModel()
      }
    } else {
      this.model = this.getDefaultCashRegisterModel()
    }
  }

  updateRegister(register: UpdateCashRegisterModel) {
    this.isRequestProcessing = true

    this.updateCashRegister(register, this.isCredentialsSettingOpen)
      .then(res => {
        if (res) {
          successNotificationWrapper(this.$t('success').toString(), '')

          this.isModalOpen = false
        }
      })
      .finally(() => {
        this.isRequestProcessing = false
      })
  }

  createRegister(register: CreateCashRegisterModel) {
    this.isRequestProcessing = true

    this.createCashRegister(register)
      .then(res => {
        if (res) {
          this.inputCashRegister(res)

          successNotificationWrapper(this.$t('success').toString(), '')

          this.isModalOpen = false
        }
      })
      .finally(() => {
        this.isRequestProcessing = false
      })
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  okClick() {
    if (this.model) {
      const modelIsValid = this.model.data?.validate?.bind(this.model.data)
      const warn = () => warningNotificationWrapper(this.$t('warning').toString(), this.$t('fill_data_alert').toString())

      if ('id' in this.model) {
        if (this.isCredentialsSettingOpen) {
          if (modelIsValid) {
            this.updateRegister(this.model)
          } else {
            warn()
          }
        } else {
          this.updateRegister(this.model)
        }
      } else {
        if (modelIsValid) {
          this.createRegister(this.model)
        } else {
          warn()
        }
      }
    }
  }
}
